import {createApi} from '@common/apis/api.js';
import {getQuery} from '@common/utils/urlUtils';

const api = createApi();

export default ({
    /**
     * 수강 신청 정보 요청
     * @param surveyReferenceNo
     * @param receiverReferenceNo
     * @param provider
     * @param isMasking
     * @returns {Promise<AxiosResponse<T>>}
     */
    getSurveyAnswer({surveyReferenceNo, receiverReferenceNo, provider, isMasking}) {
        return api.get('surveys/answers', {
            params: {
                surveyReferenceNo,
                receiverReferenceNo,
                provider,
                isMasking,
            },
        });
    },

    /**
     * 설문 읽음처리
     * @param surveyNo
     * @param surveyReceiverNo
     */
    patchSurveyReceiverRead({surveyNo, surveyReceiverNo}) {
        if (getQuery().token) {
            return Promise.resolve();
        }
        return api.patch(`surveys/${surveyNo}/receivers/${surveyReceiverNo}/read`);
    },

    /**
     * 응답 안 할래요 요청
     * @param surveyNo
     * @param surveyReceiverNo
     * @param receiverReferenceNo
     * @returns {Promise<AxiosResponse<T>>}
     */
    deleteSurveyAnswers({surveyNo, surveyReceiverNo, receiverReferenceNo}) {
        return api.delete(`surveys/${surveyNo}/answers`, {
            data: {
                surveyReceiverNo,
                receiverReferenceNo
            }
        });
    },

    /**
     * 응답 제출
     * @param surveyNo
     * @param request
     * @returns {Promise<AxiosResponse<T>>}
     */
    postSurveyAnswers({surveyNo, request}) {
        return api.post(`surveys/${surveyNo}/answers`, request);
    }
});
